import React, { Component } from 'react';

class Feature2 extends Component {
    constructor(props){
        super(props);
        this.state = {
           features: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Local Authorities',
                    text: 'Provided by local authorities to support nurseries and schools'
                },
                {
                    id: 2,
                    icon: 'bi bi-article',
                    title: 'Nursery Providers',
                    text: 'Adopted by nurseries and childminders within the local authority'
                },
                {
                    id: 3,
                    icon: 'bi bi-badge3',
                    title: 'Schools',
                    text: 'Adopted by schools within the local authority'
                }
            ]
        }
    }

    render() {
        return (
            <section className="feature-2 section-padding ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Who is School Ready for?</h3>
                                <p>The Northumberland School Readiness Passport is a transition document for Early Years education settings.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        {
                            this.state.features.map((data,index) => (
                                <div className="col-lg-4 col-md-6">
                                    <div className="feature-style-2 mb-4 mb-lg-0" key={data.id}>
                                        <i className={data.icon}></i>
                                        <div className="feature-text">
                                            <h4>{data.title}</h4>
                                            <p>{data.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        
                    </div>
                </div>
            </section> 
        );
    }
}

export default Feature2;
